import Franchise1 from "./Franchise1.template";
import Franchise2 from "./Franchise2.template";

export default [Franchise1, Franchise2];
